import { Hit } from '../../rpc/admin/search_pb';
import { Supplier } from '../../rpc/admin/suppliers_pb';

export function priceTag(productPrice: number, products: Hit[] | null): string {
    if (!products?.length) {
        return '';
    }

    let hasLower = false;
    let hasHigher = false;

    products.forEach((product) => {
        if (productPrice < product.getPrice()) {
            hasHigher = true;
        } else if (productPrice > product.getPrice()) {
            hasLower = true;
        }
    });

    if (hasLower && hasHigher) {
        return 'tag is-warning';
    } else if (hasLower) {
        return 'tag is-danger';
    } else if (hasHigher) {
        return 'tag is-success';
    }
    return 'tag is-dark';
}

export function supplierPriceTag(supplier: Supplier, productPrice: number, products: Hit[] | null): string {
    if (!products?.length) {
        return '';
    }

    let hasLower = false;
    let hasHigher = false;

    let supplierPrice = 0;
    const prices: number[] = [productPrice];
    products.forEach((product) => {
        if (supplier !== product.getSupplier()) {
            prices.push(product.getPrice());
        } else {
            supplierPrice = product.getPrice();
        }
    });

    prices.forEach((price) => {
        if (supplierPrice < price) {
            hasHigher = true;
        } else if (supplierPrice > price) {
            hasLower = true;
        }
    });

    if (hasLower && hasHigher) {
        return 'tag is-warning';
    } else if (hasLower) {
        return 'tag is-danger';
    } else if (hasHigher) {
        return 'tag is-success';
    }
    return 'tag is-dark';
}

export function qohTag(supplier: Supplier, productQoh: number, products: Hit[] | null): string {
    if (!products?.length) {
        return 'tag is-dark';
    }
    if (supplier === Supplier.SUPPLIER_UNKNOWN && productQoh === 0) {
        return 'tag is-danger';
    }

    let hasLower = false;
    let hasHigher = false;

    products.forEach((product) => {
        if (supplier !== product.getSupplier()) {
            if (productQoh < product.getQoh()) {
                hasHigher = true;
            } else if (productQoh > product.getQoh()) {
                hasLower = true;
            }
        } else {
            if (product.getQoh() === 0) {
                return 'tag is-danger';
            }
            if (productQoh > product.getQoh()) {
                hasHigher = true;
            } else if (productQoh < product.getQoh()) {
                hasLower = true;
            }
        }
    });

    if (hasLower && hasHigher) {
        return 'tag is-warning';
    } else if (hasLower) {
        return 'tag is-success';
    } else if (hasHigher) {
        return 'tag is-danger';
    }
    return 'tag is-dark';
}